<template>
  <base-toolbar>
    <BackToFlatplan :reload="true" />
    <v-btn v-if="!isDemo" variant="text" :to="{ name: 'api-key-add' }" color="primary" :prepend-icon="mdiCloudKey" exact>
      <span v-if="!mobile">Add</span>
    </v-btn>
  </base-toolbar>
</template>

<script>
import { inject } from "vue"
import BackToFlatplan from "@/components/BackToFlatplan"
import { mdiCloudKey } from "@mdi/js"
import { useBilling } from "@/modules/billing/use"

export default {
  name: "ApiKeysToolBar",
  components: {
    BackToFlatplan,
  },
  setup() {
    let bp_billing = useBilling()
    let mobile = inject("mobile")

    return {
      mobile,
      isDemo: bp_billing.isDemo,
      mdiCloudKey,
    }
  },
}
</script>

<style lang="scss" scoped></style>
